import React, { useState } from "react";
import { Linkedin, Twitter, Facebook, Instagram, Youtube, Globe } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const SOCIAL_ICONS = { linkedin: Linkedin, twitter: Twitter, x: Twitter, facebook: Facebook, instagram: Instagram, youtube: Youtube };

const LEGAL_LINKS = [
  { key: "legal_privacy", label: "Privacy policy" },
  { key: "legal_terms", label: "Terms" },
  { key: "legal_cookies", label: "Cookies" },
  { key: "legal_contact", label: "Contact" },
];

export default function Footer({ content = {} }) {
  const cols = content.footer_columns || [];
  const tagline = content.footer_tagline || "";
  const socials = (content.social_links || []).filter((s) => s && s.url);
  const [openKey, setOpenKey] = useState(null);
  const active = openKey ? content[openKey] || {} : {};

  return (
    <footer id="contact" className="text-white pt-20 pb-10" style={{ backgroundColor: content.footer_bg_color || "#101c30" }}>
      <div className="max-w-[1180px] mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              {content.site_logo ? (
                <img src={content.site_logo} alt="GiftVouchers.app" className="h-9 w-auto object-contain" />
              ) : (
                <span className="text-2xl font-semibold">GiftVouchers.app</span>
              )}
            </div>
            <p className="text-white/60 text-[0.95rem] leading-relaxed max-w-[300px]">{tagline}</p>
            <div className="flex gap-3 mt-6">
              {socials.map((s, i) => {
                const Icon = SOCIAL_ICONS[(s.platform || "").toLowerCase()] || Globe;
                return (
                  <a key={i} href={s.url || "#"} target="_blank" rel="noreferrer" data-testid={`footer-social-${(s.platform || "link").toLowerCase()}`}
                    className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#2ec9c9] transition-colors">
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {cols.map((col, ci) => (
            <div key={ci}>
              <h4 className="font-semibold text-[1rem] mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {(col.links || []).map((l, li) => (
                  <li key={li}>
                    <a href={l.url || "#"} className="text-white/60 text-[0.9rem] hover:text-[#2ec9c9] transition-colors">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-14 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-[0.85rem]">© {new Date().getFullYear()} GiftVouchers.app. All rights reserved.</p>
          <div className="flex flex-wrap gap-6 justify-center">
            {LEGAL_LINKS.map(({ key, label }) => (
              <button key={key} type="button" onClick={() => setOpenKey(key)} data-testid={`footer-link-${key}`}
                className="text-white/60 text-[0.85rem] hover:text-white transition-colors">
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <Dialog open={!!openKey} onOpenChange={(o) => !o && setOpenKey(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="legal-modal">
          <DialogHeader>
            <DialogTitle className="text-[#16243b] text-2xl" data-testid="legal-modal-title">{active.title || ""}</DialogTitle>
            <DialogDescription className="sr-only">{active.title || "Information"}</DialogDescription>
          </DialogHeader>
          <div className="text-[#5a6b80] text-[0.95rem] leading-relaxed whitespace-pre-line" data-testid="legal-modal-body">
            {active.body || "Content coming soon."}
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
